import { EnvironmentProviders, Provider } from '@angular/core';
import { UserInterface } from '@techniek-team/common';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { provideTtAuth } from './auth.provider';
import { OidcOauthInputConfig } from './config/oidc-oauth.config';
import { providePresetUser } from './preset-user-testing.provider';
import { LoggerService } from './service/internal/logger.service';
import { LoggerServiceMock } from './service/internal/logger.service.mock';
import { OAuthServiceMock } from './service/oauth/oauth.service.mock';
import { LocalSecurityStorage } from './service/storage/local-security.storage';
import { LocalSecurityStorageMock } from './service/storage/local-security.storage.mock';
import { UserService } from './service/user/user.service';
import { UserServiceMock } from './service/user/user.service.mock';
import { OidcSecurityServiceMock } from './testing/oidc-security-service.mock';

export function provideTtAuthTesting<T extends UserInterface>(
  options: OidcOauthInputConfig<T>,
  ...features: (
    | (Provider | EnvironmentProviders)[]
    | { options: OidcOauthInputConfig<T>; providers: (Provider | EnvironmentProviders)[] }
  )[]
) {
  return [
    provideTtAuth(options, ...features),
    { provide: LocalSecurityStorage, useClass: LocalSecurityStorageMock },
    { provide: OidcSecurityService, useClass: OidcSecurityServiceMock },
    { provide: LoggerService, useClass: LoggerServiceMock },
    { provide: UserService, useClass: UserServiceMock },
    { provide: OAuthServiceMock, useClass: OAuthServiceMock },
    providePresetUser(),
  ];
}
